export default __webpack_public_path__ + "static/media/card1.0f187fe5.png";